import styled from 'styled-components';

import StackContainer from '@ad-scripts/presentation/components/common/containers/stack_container';

const EmptyPageLayout = styled(StackContainer).attrs({ stack: 'none', inset: 'none' })`
  align-items: center;
  background-color: ${p => p.theme.colors.white};
  border-radius: ${p => p.theme.borderRadius.large};
  box-shadow: ${p => p.theme.boxShadow.default};
  flex-shrink: 1;
  justify-content: center;
  line-height: 162%;
  margin: 24px 8px 24px 4px;
  max-width: 1200px;
  min-height: 558px;
  overflow: hidden;
  width: 100%;

  @media (max-width: 1280px) {
    margin-right: 16px;
  }
`;

export default EmptyPageLayout;
